if(document.querySelector('.product-header-block')){
    function onMiniTrustPilotrRender(element) {
        if (productHeaderBlock) productHeaderBlock.querySelector('.trustpilot__placeholder_0').appendChild(element);
    }
    const productHeaderBlock = document.querySelector('.product-header-block');
    const config = { childList: true, subtree: false };
    const onMiniTrustPilotCallback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.getAttribute("id") === "trustpilot-widget-trustbox-2-wrapper" ) {
                        onMiniTrustPilotrRender(node);
                        observer.disconnect();
                    }
                });
            }
        }
    };
    const observerTrustPilotMini = new MutationObserver(onMiniTrustPilotCallback);
    observerTrustPilotMini.observe(productHeaderBlock, config);
}


const initializedRichText = document.querySelector('.rich-text__outer-container#trustpilot-section');
const targettedTrustPilotMainSection = document.querySelector('#trustpilot-section');
if (initializedRichText && targettedTrustPilotMainSection) {
	const targettedTrustPilotBlock = targettedTrustPilotMainSection.querySelector('.trustpilot-block');
    const config = { childList: true, subtree: true }; 
    const onSliderTrustPilotCallback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.getAttribute("id") === "trustpilot-widget-trustbox-1-wrapper") {

                        targettedTrustPilotBlock.appendChild(node);
                        observer.disconnect();
                    }
                });
            }
        }
    };

    const observerTrustPilotSlider = new MutationObserver(onSliderTrustPilotCallback);
    observerTrustPilotSlider.observe(initializedRichText, config);

} 


const checkWidget = setInterval(() => {
    const widget = document.querySelector('#trustpilot-widget-trustbox-1-wrapper iframe');
    if (widget && widget.contentDocument?.body.innerHTML.trim() !== '') {
        console.log('Trustpilot widget is loaded and ready!');

        setTimeout(() => {
            // Get the Trustpilot element
            const trustpilotWidget = document.querySelector('#trustpilot-widget-trustbox-1-wrapper');

            // Get the target container
            const trustpilotBlock = document.querySelector('#trustpilot-section .trustpilot-block');

            if (trustpilotWidget && trustpilotBlock) {
                // Move the element into the container
                trustpilotBlock.appendChild(trustpilotWidget);
            }
        }, 100);
        clearInterval(checkWidget);
    }
}, 100);
